/**
 * Created by tofael on 11/7/17.
 */
/**
 * Created by tofael on 11/4/17.
 */

import React from 'react';
import TextField from 'material-ui/TextField';
import {green500, white} from 'material-ui/styles/colors';
import {typography} from 'material-ui/styles';
import RaisedButton from 'material-ui/RaisedButton';
import Checkbox from 'material-ui/Checkbox';
import Divider from 'material-ui/Divider';
import UplodIcon from 'material-ui/svg-icons/action/backup';
import { RadioButton, RadioButtonGroup } from "material-ui/RadioButton";

const style = {
  form: {
    marginLeft: 10,
    marginRight: 10
  },
  box: {
    backgroundColor: '#fff',
    transition: 'none',
    border: 'none',
    borderRadius: '5px',
    position: 'relative',
    marginBottom: '24px',
    boxShadow: '0 5px 5px 0 rgba(0,0,0,.25)',
    overflow: 'hidden'
  },
  button: {
    marginTop: 12,
    marginBottom: 12,
    marginRight: 12,
    float: 'right'
  },
  photo: {
    marginTop: 12,
    marginBottom: 12,
    marginRight: 12,
    float: 'left'
  },
  checkbox: {
    marginTop: 20,
    marginRight: 5,
    marginLeft: "15px",
  },
  header: {
    fontSize: 18,
    marginTop: 20,
    fontWeight: typography.fontWeightLight
  },
  roleRadios: {
    marginLeft: "15px",
    display: "inline-block",
  },
  roleText: {
    float: "left",
    marginTop: "12px",
    fontSize: "15px",
    marginLeft: "15px",
    display: "inline-block",
  },
  buttonGroup: {
    paddingTop: "30px",
    paddingBottom: "15px",
    marginLeft: "40%",
  },
  roleFields: {
    height: "30px",
    width: "50%",
    marginTop: "10px",
    display: "inline-block",
  }
};

const AdminForm = (props) => {
  const {handleChange, handleSubmit, onCheck, create_admin, handleSelect, onPhotoSelect} = props;
  const {name, user_name, user_id, email, phone, photo, address_line_1, address_line_2, postal_code, city, role, isLoading, admin, super_admin} = props;

  return (
    <div style={style.box}>
      <form style={style.form} onSubmit={handleSubmit}>
        <TextField
          hintText="Name"
          floatingLabelText="Name"
          underlineShow={false}
          required={true}
          value={name}
          onChange={handleChange.bind(null, 'name')}
        />
        <Divider />
        <TextField
          hintText="Username"
          floatingLabelText="username"
          underlineShow={false}
          required={true}
          value={user_name}
          disabled={user_id!== undefined}
          onChange={handleChange.bind(null, 'user_name')}
        />
        <Divider />
        <TextField
          hintText="Email"
          floatingLabelText="Email"
          underlineShow={false}
          required={true}
          value={email}
          onChange={handleChange.bind(null, 'email')}
        />
        <Divider />
        <TextField
          hintText="Phone"
          floatingLabelText="Phone"
          underlineShow={false}
          required={true}
          value={phone}
          disabled={user_id!== undefined}
          onChange={handleChange.bind(null, 'phone')}
        />
        <Divider />
        <TextField
          hintText="Address Line 1"
          floatingLabelText="Address Line 1"
          underlineShow={false}
          required={true}
          value={address_line_1}
          disabled={user_id!== undefined}
          onChange={handleChange.bind(null, 'address_line_1')}
        />
        <Divider />
        <TextField
          hintText="Address Line 2"
          floatingLabelText="Address Line 2"
          underlineShow={false}
          required={true}
          value={address_line_2}
          disabled={user_id!== undefined}
          onChange={handleChange.bind(null, 'address_line_2')}
        />
        <Divider />
        <TextField
          hintText="Post Code"
          floatingLabelText="Post Code"
          underlineShow={false}
          required={true}
          type="number"
          value={postal_code}
          disabled={user_id!== undefined}
          onChange={handleChange.bind(null, 'postal_code')}
        />
        <Divider />
        <TextField
          hintText="City"
          floatingLabelText="City"
          underlineShow={false}
          required={true}
          value={city}
          disabled={user_id!== undefined}
          onChange={handleChange.bind(null, 'city')}
        />
        <Divider />
        {
        create_admin && 
        <div>
        <div style={style.header}>Select Role </div>
        <RadioButtonGroup
          name="role"
          required={true}
          valueSelected={role}
          style={style.roleRadios}
          onChange={handleSelect.bind(null, 'role')}
        >
          <RadioButton
            value="admin"
            label="admin"
            style={style.roleFields}
          />
          <RadioButton
            value="scheduler"
            label="scheduler"
            style={style.roleFields}
          />
           <RadioButton
            value="rmg"
            label="RMG"
            style={style.roleFields}
          />
        </RadioButtonGroup>
        {
          admin && 
          <Checkbox
            label="Super admin"
            style={style.checkbox}
            checked={super_admin}
            onCheck={onCheck.bind(null, 'super_admin')}
          />
        }
        </div>
        }
        <div style={style.photo}>
        <RaisedButton
          containerElement="label"
          icon={<UplodIcon/>} // material-ui-icons
          label="Select Photo">
            <input
              onChange={e => onPhotoSelect(e)}
              style={{ display: 'none' }}
              type="file"
            />
        </RaisedButton>
          {
            photo &&
            photo.name
          }
        </div>  
        <div style={style.button}>
          <RaisedButton
            label="Submit"
            type="submit"
            backgroundColor={green500}
            labelColor={white}
            disabled={isLoading}
          />
        </div>
      </form>
    </div>
  )
}

export default AdminForm;




// WEBPACK FOOTER //
// ./src/screens/shared/admin-form.js